import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("DocumentGetInput")
export class DocumentGetInput {
    @JsonProperty("mediaId", String, true)
    public mediaId: string = JsonPropertyEmpty;

    public constructor(args?: Partial<DocumentGetInput>) {
        Object.assign(this, args);
    }
}
